"use client";

import {JSX} from "react";

import {useTranslation} from "@/shared/i18n";

interface GuestsButtonSmProps {
    totalGuests: number;
    totalPets: number;
    isOpen: boolean;
    onClick: () => void;
}

export function GuestsButtonSm({totalGuests, totalPets, onClick}: GuestsButtonSmProps): JSX.Element {
    const {t} = useTranslation("search");

    const guestsText = totalGuests === 0 ? t("guests") : t("guestsCount", {count: totalGuests});
    const petsText = t("dogsCount", {count: totalPets});

    return (
        <div className="guests-view__trigger-wrapper">
            <button type="button" onClick={onClick} className="guests-view__trigger input-field__wrapper">
                <div className="guests-view__content">
                    <div className="guests-view__content-guests">
                        {guestsText}
                        {totalPets > 0 && ", "}
                    </div>
                    {totalPets > 0 && <div className="guests-view__content-pets">{petsText}</div>}
                </div>
            </button>
        </div>
    );
}
